import { render, staticRenderFns } from "./DeviceRegrades.vue?vue&type=template&id=2dd0b19c&scoped=true&"
import script from "./DeviceRegrades.vue?vue&type=script&lang=js&"
export * from "./DeviceRegrades.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRegrades.vue?vue&type=style&index=0&id=2dd0b19c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0b19c",
  null
  
)

export default component.exports